import { localizedRouteGroup } from 'routing/routes';

import { EVENT_URL_SEGMENTS } from './event.route-segments';

export const eventSegmentedRoutes = EVENT_URL_SEGMENTS.flatMap(
  (eventUrlSegment) => [
    localizedRouteGroup.route(`${eventUrlSegment}/:eventIdDashSlug`),
    localizedRouteGroup.route(`amp/${eventUrlSegment}/:eventIdDashSlug`),
  ],
);
